// The algorithm's `message` is authored for the CLINICAL product, whose reader is
// the patient, so it ends with medication-counselling lines (iron/calcium spacing
// around levothyroxine). The study UI shows that message to an endocrinologist
// comparing two doses — patient counselling has no place there.
//
// Stripping happens at DISPLAY time only: api_response_data keeps the response
// verbatim, which is what the analysis, the audit trail and any re-scoring read.
// If the backend changes the wording, an unmatched line simply shows up again —
// it is never silently dropped from the stored record.
const PATIENT_GUIDANCE = [
  /^(iron|calcium)\s+supplements\b/i,
  /^timing important\b/i,
  // No \b here: it is an ASCII word boundary, so it never fires after a Greek letter.
  /^Συμπληρώματα\s+(σιδήρου|ασβεστίου)/i,
];

// Lines arrive prefixed with ⚠️ / ⏰; match on the text, not the decoration.
const withoutLeadingSymbols = (line: string) => line.trim().replace(/^[^\p{L}]+/u, '');

export const stripPatientGuidance = (message: string | null | undefined): string | null => {
  if (!message) return null;
  const kept = message
    .split('\n')
    .filter((line) => {
      const text = withoutLeadingSymbols(line);
      return !PATIENT_GUIDANCE.some((pattern) => pattern.test(text));
    })
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
  return kept || null;
};
